import React, { useState } from "react";
import { TYPE } from "../../constants/theme";

const MONO = TYPE.mono.fontFamily;

export default function TicketChip({ ticketKey, onClick, dark = true, style = {} }) {
  const [hov, setHov] = useState(false);
  if (!ticketKey) return null;

  const handleClick = (e) => {
    if (onClick) onClick(ticketKey, e);
  };

  return (
    <span
      onClick={handleClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        fontFamily: MONO,
        fontSize: dark ? 13 : 12,
        fontWeight: dark ? 600 : 700,
        color: dark ? "#93C5FD" : "#2563EB",
        cursor: "pointer",
        textDecoration: hov ? "underline" : "none",
        textUnderlineOffset: 2,
        filter: hov ? "brightness(1.2)" : "none",
        transition: "filter 0.12s ease",
        ...style,
      }}
    >
      {ticketKey}
    </span>
  );
}
